import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (localStorage.getItem("kspb_admin_token")) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/admin/login", { email, password });
      localStorage.setItem("kspb_admin_token", r.data.token);
      localStorage.setItem("kspb_admin_email", r.data.email);
      toast.success("Welcome back!");
      nav("/admin");
    } catch {
      toast.error("Invalid credentials");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-160px)] flex items-center justify-center py-14 px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md p-8 rounded-2xl border border-slate-200 bg-white">
        <div className="inline-flex w-12 h-12 rounded-xl bg-[#0A192F] text-white items-center justify-center"><Lock className="w-5 h-5" /></div>
        <h1 className="font-heading text-2xl font-bold text-[#0A192F] mt-4">Admin Sign In</h1>
        <p className="text-sm text-slate-500 mt-1">Restricted area. Authorised personnel only.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="text-xs font-semibold text-slate-600 uppercase tracking-wider">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email"
              className="mt-1.5 w-full h-11 px-3 rounded-lg border border-slate-200 focus:border-[#FF6D00] outline-none" />
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-600 uppercase tracking-wider">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password"
              className="mt-1.5 w-full h-11 px-3 rounded-lg border border-slate-200 focus:border-[#FF6D00] outline-none" />
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-btn"
            className="w-full h-12 rounded-full bg-[#FF6D00] text-white font-semibold hover:bg-[#ff8433] transition-colors disabled:opacity-50">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
